<div style="display: flex; flex-direction: column">
  <div class="d-flex justify-content-center" id="breadcrumb">
    <ng-casto-breadcrumb
      [currentPage]="'Récapitulatif'"
      [isUnlocked]="this.tunnelService.kitchenTunnelData.bom"></ng-casto-breadcrumb>
  </div>

  <div *ngIf="projectIsSaved">
    <p-messages [(value)]="messages" [closable]="false"></p-messages>
    <div class="container-fluid" id="prices">
      <div class="row">
        <div class="col-md-9 prices-panel">
          @if (this.isDataLoading) {
            <div class="card" id="product-prices">
              <div class="card-header prices-header">
                <strong><span [innerHtml]="'popins.installation.opt1_title' | translate"></span></strong>
              </div>
              <div class="card-body">
                <ng-casto-loader></ng-casto-loader>
              </div>
            </div>
          } @else if (!this.kitchenPricing) {
            {{ installationError }}
          } @else {
            <div class="card" id="product-prices">
              <div class="card-header prices-header">
                <strong><span [innerHtml]="'popins.installation.opt1_title' | translate"></span></strong>
                <div class="price">
                  @if (totalWithoutInstallation >= 0) {
                    <span style="font-size: larger">
                      {{ totalWithoutInstallation | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                    </span>
                  }
                </div>
              </div>

              <div class="card-body">
                <div class="d-flex justify-content-end">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="pl-3 excludePrint">Remise</span>
                    <p-selectButton
                      class="excludePrint pl-3 discount"
                      [options]="DiscountValues"
                      [(ngModel)]="DiscountValue"
                      (onChange)="setInstallationData()">
                      <ng-template let-item pTemplate="item">
                        <div class="d-flex flex-column align-items-center">
                          <span>{{ item.label }}</span>
                        </div>
                      </ng-template>
                    </p-selectButton>
                  </div>
                </div>

                <div
                  class="col-auto subtitle mb-2 font-weight-bold"
                  [innerHtml]="'popins.installation.opt1_subtitle' | translate"></div>
                <div class="col">
                  <table>
                    <tr *ngFor="let productCategory of totalByCategories">
                      <td class="pl-5">
                        <span [innerHtml]="'popins.installation.opt1_' + productCategory.key | translate"></span>
                      </td>
                      <td
                        class="pl-5 font-weight-bold"
                        [ngClass]="{
                          'text-decoration-line-through': isDiscount,
                        }">
                        {{
                          productCategory.price || productCategory.subTotal
                            | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                        }}
                      </td>
                      <td class="pl-5 font-weight-bold text-danger" *ngIf="isDiscount">
                        {{
                          this.productPricewithoutInstallationbyCategory(productCategory.key)
                            | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                        }}
                      </td>
                    </tr>
                    @if (this.workbench3DPrice) {
                      <tr>
                        <td class="pl-5">
                          <span>Dont plan de travail standard</span>
                        </td>
                        <td
                          class="pl-5"
                          [ngClass]="{
                            'text-decoration-line-through': isDiscount,
                          }">
                          {{ this.workbench3DPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                        <td class="pl-5 text-danger" *ngIf="isDiscount">
                          {{ this.workbench3DPriceDiscount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                      </tr>
                    }
                    <hr/>
                    <tr>
                      <td class="pl-5">
                        <span [innerHtml]="'popins.installation.opt2_shipping' | translate"></span>
                      </td>
                      <td class="pl-5 font-weight-bold">
                        {{ shippingPricewithoutInstallation | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                      </td>
                    </tr>
                    @if (this.isCustomWorkbench) {
                      <hr/>
                      <tr>
                        <td class="pl-5">
                          @if (this.workbenchPackagePrice) {
                            <span
                            >Chiffrage du plan de travail sur-mesure (avec forfait pose, livraison comprise)
                              (TTC)</span
                            >
                          } @else {
                            <span
                            >Chiffrage du plan de travail sur-mesure (sans forfait pose, livraison comprise)
                              (TTC)</span
                            >
                          }
                        </td>
                        <td
                          class="pl-5 font-weight-bold"
                          [ngClass]="{
                            'text-decoration-line-through': isDiscount,
                          }">
                          {{ this.workbenchTotalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                        <td class="pl-5 font-weight-bold text-danger" *ngIf="isDiscount">
                          {{ this.workbenchTotalPriceDiscount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                        <td class="pl-5">
                          <button class="btn btn-link excludePrint" type="button" (click)="openDetailWorkbench()">
                            Détails du chiffrage
                          </button>
                        </td>
                      </tr>
                      @if (this.workbenchPackagePrice) {
                        <tr>
                          <td class="pl-5">
                            <span>Dont plan de travail sur-mesure : </span>
                          </td>
                          <td
                            class="pl-5"
                            [ngClass]="{
                              'text-decoration-line-through': isDiscount,
                            }">
                            {{ this.workbenchProductPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                          </td>
                          <td class="pl-5 text-danger" *ngIf="isDiscount">
                            {{ this.workbenchProductPriceDiscount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                          </td>
                        </tr>

                        @if (this.workbenchInstallationPrice) {
                          <tr>
                            <td class="pl-5">
                              <span>Dont forfait de pose : </span>
                            </td>
                            <td class="pl-5">
                              {{ this.workbenchInstallationPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                            </td>
                          </tr>
                        }
                        @if (this.workbenchTransportPrice) {
                          <tr>
                            <td class="pl-5">
                              <span>Dont livraison : </span>
                            </td>
                            <td class="pl-5">
                              {{ this.workbenchTransportPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                            </td>
                          </tr>
                        }
                      }
                    }
                  </table>
                </div>
              </div>
            </div>
          }
          @if (this.isDataLoading) {
            <div class="card" id="installation-prices">
              <div class="card-header prices-header">
                <div>
                  <span
                    *ngIf="isLess2Years !== false"
                    [innerHTML]="'popins.installation.opt2_title' | translate"></span>
                  <span
                    *ngIf="isLess2Years === false"
                    [innerHTML]="'popins.installation.opt2_title_tva' | translate"></span>
                </div>
              </div>
              <div class="card-body">
                <ng-casto-loader></ng-casto-loader>
              </div>
            </div>
          } @else if (!this.kitchenPricing) {
          } @else {
            <div class="card" id="installation-prices">
              <div class="card-header prices-header">
                <div>
                  <!-- <span *ngIf="isLess2Years !== false" [innerHTML]="'popins.installation.opt2_title' | translate"></span>
                <span *ngIf="isLess2Years === false" [innerHTML]="'popins.installation.opt2_title_tva' | translate"></span> -->
                  <span *ngIf="isLess2Years === false"
                  ><strong>Votre cuisine livrée et posée (TVA réduite 10%)<sup>(1)</sup></strong></span
                  >
                  <span *ngIf="isLess2Years !== false"><strong>Votre cuisine livrée et posée</strong></span>
                </div>
                <div class="price" *ngIf="isLess2Years !== null">
                  <span style="font-size: larger">
                    {{ totalWithInstallation | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                  </span>
                </div>
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="pl-3 excludePrint">Habitation de plus de 2 ans ?</span>
                    <p-selectButton
                      class="excludePrint pl-3"
                      [options]="isLess2YearsValues"
                      [(ngModel)]="isLess2Years"
                      inputId="tricheckbox_isLess2Years"
                      (onChange)="setInstallationData()"
                      optionLabel="label"
                      optionValue="value"/>
                  </div>
                </div>

                <div *ngIf="isLess2Years !== null">
                  <div
                    class="col-auto subtitle mb-2 font-weight-bold mt-2"
                    [innerHtml]="'popins.installation.opt2_subtitle' | translate"></div>
                  <div class="col">
                    <table>
                      <tr>
                        <td class="pl-4 pb-1">
                          <strong>1. PRODUITS</strong>
                        </td>
                      </tr>

                      <tr *ngIf="isLess2Years === false">
                        <td class="pl-5 mb-2">
                          <span [innerHtml]="'popins.installation.opt2_reduceVat' | translate"></span>
                        </td>
                        <td
                          class="pl-5 mb-2"
                          [ngClass]="{
                            'text-decoration-line-through': isDiscount,
                          }">
                          {{ this.totalproductPrice10 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                        <td class="pl-5 font-weight-bold text-danger" *ngIf="isDiscount">
                          {{ this.totalProductPrice10Discount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-5 mb-2">
                          <span [innerHtml]="'popins.installation.opt2_appliances' | translate"></span>
                        </td>
                        @if (isLess2Years) {
                          <td
                            class="pl-5 mb-2 mt-1"
                            [ngClass]="{
                              'text-decoration-line-through': isDiscount,
                            }">
                            {{ this.productPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                          </td>

                          <td class="pl-5 font-weight-bold text-danger" *ngIf="isDiscount">
                            {{ this.productPriceDiscount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                          </td>
                        } @else {
                          <td
                            class="pl-5 mb-2 mt-1"
                            [ngClass]="{
                              'text-decoration-line-through': isDiscount,
                            }">
                            {{ totalProductPrice20 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                          </td>

                          <td class="pl-5 font-weight-bold text-danger" *ngIf="isDiscount">
                            {{ this.totalProductPrice20Discount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                          </td>
                        }
                      </tr>
                      @if (this.workbenchInstallationPrice) {
                        <tr>
                          <td class="pl-5">
                            <span>Forfait de pose du plan de travail : </span>
                          </td>
                          <td class="pl-5">
                            {{ this.workbenchInstallationPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                          </td>
                        </tr>
                      }
                      @if (this.workbenchPackageWithoutInstallationPrice) {
                        <tr>
                          <td class="pl-5">
                            <span>Forfaits plan de travail (hors pose) (TTC)</span>
                          </td>
                          <td class="pl-5">
                            {{
                              this.workbenchPackageWithoutInstallationPrice
                                | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                            }}
                          </td>
                        </tr>
                      }

                      <tr class="sous-total">
                        <td class="pl-5">
                          <span>Sous total produits</span>
                        </td>
                        <td
                          class="pl-5 font-weight-bold"
                          [ngClass]="{
                            'text-decoration-line-through': isDiscount,
                          }">
                          {{ this.totalProductPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                        <td class="pl-5 font-weight-bold text-danger" *ngIf="isDiscount">
                          {{ this.totalProductPriceDiscount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                      </tr>
                      <hr/>
                      <tr>
                        <td class="pl-4 pb-1">
                          <strong>2. POSE</strong>
                        </td>
                      </tr>

                      @if (isLess2Years === false) {
                        <tr>
                          <td class="pl-5 mb-2">
                            <span [innerHtml]="'popins.installation.opt2_installation' | translate"></span>
                          </td>
                          <td class="pl-5 mb-2">
                            <span class="formated-price">{{
                                this.installationProductPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                              }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-5 mb-2">
                            <span [innerHtml]="'popins.installation.opt2_installation_appliances' | translate"></span>
                          </td>
                          <td class="pl-5 mb-2">
                            <span class="formated-price">{{
                                this.installationAppliancePrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                              }}</span>
                          </td>
                        </tr>
                      }

                      <tr class="sous-total">
                        <td class="pl-5">
                          <span [innerHtml]="'popins.installation.installation' | translate"></span>
                        </td>
                        <td class="pl-5">
                          <span class="formated-price font-weight-bold">{{
                              this.installationPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                            }}</span>
                        </td>
                        <td class="pl-1 excludePrint">
                          <button
                            id="detail-button"
                            class="btn btn-link excludePrint"
                            type="button"
                            (click)="openDetail()">
                            Détails de la pose
                          </button>
                        </td>
                      </tr>
                      <hr/>
                      <tr>
                        <td class="pl-4 pb-1">
                          <strong>3. LIVRAISON</strong>
                        </td>
                      </tr>

                      <tr>
                        <td class="pl-5">
                          <span [innerHtml]="'popins.installation.opt2_shipping' | translate"></span>
                        </td>
                        <td class="pl-5 font-weight-bold">
                          {{ shippingPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <hr/>
              <div
                class="delta"
                *ngIf="isLess2Years !== null"
                [innerHtml]="
                  'popins.installation.opt2_delta'
                    | translate
                      : {
                          price: delta | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></div>
              <div class="mb-2" style="display: none" id="details">
                <h2 class="my-2">
                  {{ 'popins.installation.documentTitle' | translate }}
                </h2>

                <p-table
                  [value]="installationDetails"
                  [tableStyle]="{ 'min-width': '100%', 'table-layout': 'auto' }"
                  styleClass="p-datatable-gridlines p-datatable-striped details-datatable"
                  selectionMode="single">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Prestation</th>
                      <th>Désignation</th>
                      <th>Quantité</th>
                      <th>Unité</th>
                      <th>Chiffrage estimatif unitaire de la pose</th>
                      <th>Chiffrage estimatif total de la pose</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-details>
                    <tr>
                      <td>{{ details['libellePrestation'] }}</td>
                      <td>{{ details['designation'] }}</td>
                      <td>{{ details['quantite'] }}</td>
                      <td>{{ details['unite'] }}</td>
                      <td>
                        {{ details['prixUnitairePose'] | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                      </td>
                      <td>
                        {{ details['prixTotalPose'] | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          }
        </div>
        <div class="col-md-3 right-panel">
          <div class="card" id="summary-prices">
            <div class="card-body">
              <strong>
                <h3>
                  <strong>{{ 'popins.installation.print_title_kitchen' | translate }}</strong>
                </h3>
              </strong>

              <div class="d-flex justify-content-center mb-4">
                <img [src]="projectImageUrl" alt="Project Thumbnail" style="width: 75%"/>
              </div>
              <div class="d-flex justify-content-between">
                <span>Projet : {{ projectName }}</span>
              </div>
              <div class="d-flex justify-content-between">
                <span>{{ 'popins.base-funding.kitchen_project' | translate }} : {{ projectRef }}</span>
              </div>
              <div class="d-flex justify-content-between">
                <span
                >{{ 'popins.base-funding.client_name' | translate }} <strong>{{ clientName }}</strong></span
                >
              </div>
            </div>
            <div class="card-footer">
              <div class="col">
                <div class="row">
                  <ng-casto-btn
                    [label]="'popins.installation.back' | translate"
                    class="mb-2 flex-grow-1"
                    id="return"
                    (click)="back()"></ng-casto-btn>
                </div>

                <div class="row">
                  <ng-casto-btn
                    *ngIf="vendorEnvironment"
                    (click)="printSummary()"
                    label="Imprimer"
                    [loading]="printLoading"
                    class="mb-2 flex-grow-1"
                    id="print"
                    [disabled]="isLess2Years === null"></ng-casto-btn>
                </div>
                <div class="row">
                  <ng-casto-btn
                    label="Liste d'achat"
                    class="mb-2 flex-grow-1"
                    [loading]="printLoading || this.isDataLoading"
                    [disabled]="!this.kitchenPricing"
                    (click)="showProductList()"></ng-casto-btn>
                </div>
                <div class="row">
                  <ng-casto-btn
                    *ngIf="vendorEnvironment"
                    (click)="order()"
                    label="Continuer"
                    class="mb-2 flex-grow-1"
                    [disabled]="isLess2Years === null"></ng-casto-btn>
                </div>
              </div>
              <div class="d-flex justify-content-between"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (isLess2Years === false) {
      <div class="footer">
        <div class="legacy" [innerHtml]="'popins.installation.disclaimer' | translate"></div>
      </div>
    }

    <div style="display: none">
      <div class="print-legacy" [innerHtml]="'popins.installation.disclaimer' | translate"></div>
    </div>
  </div>
  <div *ngIf="!projectIsSaved">
    <div class="d-flex justify-content-center">
      <h3>{{ 'popins.installation.project_error' | translate }}</h3>
    </div>
  </div>
  <p-dialog
    [header]="'popins.applianceWarning.title' | translate"
    [modal]="true"
    [(visible)]="warningDialogVisible"
    [style]="{ width: '30rem' }">
    <span class="p-text-secondary block mb-5">{{ 'popins.applianceWarning.text' | translate }}</span>
    <div class="d-flex justify-content-center mt-3">
      <ng-casto-btn
        class="blue"
        (click)="warningDialogVisible = false"
        [label]="'popins.applianceWarning.confirm' | translate"></ng-casto-btn>
    </div>
  </p-dialog>
</div>
